export const formatTime = (secondsInput: number, timeLeft?: boolean) => {
  const hours = Math.floor(secondsInput / 3600)
  const minutes = Math.floor((secondsInput % 3600) / 60)
  const seconds = Math.floor((secondsInput % 3600) % 60)

  return `${timeLeft ? '-' : ''}${hours > 0 ? `${hours}:` : ''}${minutes}:${
    seconds < 10 ? `0${seconds}` : `${seconds}`
  }`
}

export const formatTimeWithSuffix = (secondsInput: number) => {
  const hours = Math.floor(secondsInput / 3600)
  const minutes = Math.floor((secondsInput % 3600) / 60)
  const seconds = Math.floor((secondsInput % 3600) % 60)

  return `${hours > 0 ? `${hours} hour(s)` : ''}${minutes} mins ${
    seconds < 10 ? `0${seconds}` : `${seconds}`
  } sec`
}
